import { h } from 'vue';


const CREATED = 'created',
    FAILED = 'failed',
    CREATED_CALLBACK_PREFIX = 'onCreatedPayjpToken_',
    FAILED_CALLBACK_PREFIX = 'onFailedPayjpToken_';

/**
 * PAYJP3D支払いコンポーネント
 * vue-payjp-checkoutを移植した。
 * 移植元
 *   https://github.com/ngs/vue-payjp-checkout
 * 経緯
 *   ・2025年2月4日にpayjpの3dセキュアがリリースされる。
 *   ・それに伴い接続先URLやパラメータ名を変更する必要があるがvue-payjp-checkout内に固定で記述されているため変更できない。
 *   ・変更するには作者にプルリクを送る必要があるが、7年ほどメンテナンスされていないコードなので対応してくれるか分からず。移植することにした。
 *   ・payjpから公開されているscriptタグを直接記述してみたが、ボタンが表示されず。
 *   ・mount時にscriptタグを生成するなど、他にも特殊な条件が必要な可能性あり。調査に時間がかかりそうなのでひとまず正常に動く移植の状態でリリースする。
 */
export default {
    name: 'payjp-checkout-3dsecure',
    data () {
        return {
        };
    },
    props: {
        api_key: {
            type: String,
            required: false,
            default: ''
        },
        client_id: {
            type: String,
            required: false,
            default: ''
        },
        partial: {
            type: Boolean,
            default: false,
        },
        text: {
            type: String,
            required: false,
            default: ''
        },
        submit_text: {
            type: String,
            required: false,
            default: ''
        },
        token_name: {
            type: String,
            required: false,
            default: ''
        },
        previous_token: {
            type: String,
            required: false,
            default: ''
        },
        lang: {
            type: String,
            required: false,
            default: ''
        },
        name_placeholder: {
            type: String,
            required: false,
            default: ''
        },
    },
    render() {
        return h('div');
    },
    mounted: function () {
        const self = this;
        const emit = this.$emit.bind(this);
        const random = self.random || Math.random;

        function generateCallback(eventName, prefix) {
            const rand = Math.ceil(random() * 1e20).toString(0x10);
            const name = prefix + rand;
            const w = window;
            if (w[name]) {
                return generateCallback(eventName, prefix);
            }
            w[name] = (...args) => {
                const ret = emit(eventName, ...args);
                if (typeof w[name] === 'function') {
                    delete w[name];
                }
                const inputs = self.$el.parentElement.getElementsByTagName('input')[0] || {};
                return !!inputs.form && !!ret;
            };
            return name;
        }

        const createdCallbackName = generateCallback(
            CREATED,
            CREATED_CALLBACK_PREFIX
        );
        const failedCallbackName = generateCallback(FAILED, FAILED_CALLBACK_PREFIX);

        const scriptEl = document.createElement('script');
        // https://pay.jp/docs/checkout
        const attrs = {
            src: 'https://checkout.pay.jp',
            class: 'payjp-button',
            'data-payjp-key': this.api_key,
            'data-payjp': this.client_id,
            'data-payjp-partial': !!this.partial,
            'data-payjp-text': this.text,
            'data-payjp-submit-text': this.submit_text,
            'data-payjp-token-name': this.token_name,
            'data-payjp-previous-token': this.previous_token,
            'data-payjp-lang': this.lang,
            'data-payjp-on-created': createdCallbackName,
            'data-payjp-on-failed': failedCallbackName,
            'data-payjp-name-placeholder': this.name_placeholder,
            'data-payjp-extra-attribute-email': '',
            'data-payjp-extra-attribute-phone': '',
            'data-payjp-extra-attribute-phone-code': 'JP',
            'data-payjp-three-d-secure': 'true',
            'data-payjp-three-d-secure-workflow': 'subwindow',
        };
        Object.keys(attrs).forEach(key => {
            const value = attrs[key];
            if (typeof value !== 'undefined') {
                scriptEl.setAttribute(key, value);
            }
        });
        this.$el.parentElement.appendChild(scriptEl);
    },
    emits: [CREATED, FAILED],
};
